import IReducerReturn from '../../../store/IReducerReturn';
import * as ActionTypes from './ActionTypes';
import IOrder from './IOrder';
import ViewOrderApi from './ViewOrderApi';

function getSuccess(result: IOrder): IReducerReturn {
    return { type: ActionTypes.GET_COMMON_ORDER_SUCCESS, result: result };
}

export function get(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ViewOrderApi.get(id).then((result: IOrder) => {
            dispatch(getSuccess(result));
            return result;
        });
}

function assignUserSuccess(result: any): IReducerReturn {
    return { type: ActionTypes.ASSIGN_USER_ORDER_SUCCESS, result: result };
}

export function assignUser(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ViewOrderApi.assignUser(id).then((result: any) => {
            dispatch(assignUserSuccess(result));
        });
}

export function resetOrderStates(orderId?: number): any {
    return (dispatch: (result: any) => void) =>
        Promise.resolve(dispatch({ type: ActionTypes.RESET_ORDER_STATES, orderId }));
}

function moveOrderSuccess(result: IOrder): any {
    return { type: ActionTypes.GET_COMMON_ORDER_SUCCESS, result: result };
}

export function moveOrder(orderId: number, orderCollection: string) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ViewOrderApi.moveOrder(orderId, orderCollection).then((result: any) => {
            dispatch(moveOrderSuccess(result));
        });
}

function getOrderIdByOrderNumberSuccess(orderid: number): any {
    return { type: ActionTypes.GET_ORDERID_BY_NUMBER_SUCCESS, result: orderid };
}

export function getOrderIdByOrderNumber(orderNumber: string) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ViewOrderApi.getOrderIdByNumber(orderNumber).then((result: any) => {
            return result;
        });
}
